import { cn } from '@/lib/utils';

interface VoiceModeIconProps {
  className?: string;
  active?: boolean;
}

export function VoiceModeIcon({ className, active = false }: VoiceModeIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={cn('voice-mode-icon', active && 'voice-mode-icon-active', className)}
    >
      <rect className="voice-mode-icon-bar" x="0.75" y="6.5" width="2.5" height="11" rx="1.25" />
      <rect className="voice-mode-icon-bar" x="5.75" y="0.5" width="2.5" height="23" rx="1.25" />
      <rect className="voice-mode-icon-bar" x="10.75" y="5" width="2.5" height="14" rx="1.25" />
      <rect className="voice-mode-icon-bar" x="15.75" y="3.5" width="2.5" height="17" rx="1.25" />
      <rect className="voice-mode-icon-bar" x="20.75" y="7.5" width="2.5" height="9" rx="1.25" />
    </svg>
  );
}
